/* eslint-disable-next-line import/named */
import styled, { css } from 'styled-components';
import { injectTypography } from '../../utils/injectTypography';
import { injectOSXFontSmoothing } from '../../utils/injectOSXFontSmoothing';
import { injectSpacing } from '../../api/spacing/injectSpacing';
export const AUTO_WIDTH_BREAKPOINT = '440px';
export const StyledButtonLabel = styled.span `
  margin-inline-start: ${(props) => props.icon && `var(${props.theme.responsive.spacing.s})`};

  transform: ${(props) => props.size === 'small' && 'translateY(0.05em)'};
  ${(props) => injectOSXFontSmoothing(props.size !== 'small')}
`;
// All buttons are styled as disabled, then other styles are applied if an `href` attribute is present or the button is discovered not to be disabled.
export const injectCommonButtonStyles = (props) => css `
  position: relative;

  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  margin: 0;
  padding: 0;

  color: ${props.theme.colors.ui.disabled};
  text-align: center;
  text-decoration: none;
  vertical-align: middle;

  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0;
  outline-offset: 2px;

  cursor: not-allowed;

  transition-timing-function: ${props.theme.easing};
  transition-duration: 250ms;
  transition-property: color, background-color, border-color;

  appearance: none;

  user-select: none;

  &[href],
  &[type]:not(:disabled) {
    color: ${props.theme.colors.ui.primary};

    cursor: pointer;

    user-select: initial;

    &:hover {
      color: ${props.theme.colors.ui.hover};
    }
  }

  ${injectSpacing('margin')}
  ${injectTypography(props, props.size === 'small' ? 'copy2' : 'copy1')}
  ${injectOSXFontSmoothing(true)}
`;
export const injectBlockButtonStyles = () => css `
  justify-content: center;
  width: 100%;
  min-width: 9em;
  padding-block-start: 1em;
  padding-inline-end: 2em;
  padding-block-end: 1em;
  padding-inline-start: 2em;

  border-color: ${(props) => props.theme.colors.ui.disabled};

  &[href],
  &[type]:not(:disabled) {
    border-color: ${(props) => props.theme.colors.ui.primary};

    &:hover {
      border-color: ${(props) => props.theme.colors.ui.hover};
    }
  }

  ${(props) => props.variant === 'primary' &&
    css `
      color: ${props.theme.colors.ui.primaryInverse};
      background-color: ${props.theme.colors.ui.disabled};

      &[href],
      &[type]:not(:disabled) {
        color: ${props.theme.colors.ui.primaryInverse};
        background-color: ${props.theme.colors.ui.primary};

        &:hover {
          color: ${props.theme.colors.ui.primaryInverse};
          background-color: ${props.theme.colors.ui.hover};
        }
      }
    `}

  @media (min-width: ${AUTO_WIDTH_BREAKPOINT}) {
    width: ${(props) => (props.stretch ? '100%' : 'auto')};
  }
`;
export const injectTextButtonStyles = () => css `
  padding-inline-end: 5px;

  &[href],
  &[type]:not(:disabled) {
    ${StyledArrow} {
      stroke: ${(props) => props.theme.colors.ui.primary};
    }

    &:hover {
      ${StyledArrow} {
        transform: translateX(5px);

        [dir='rtl'] & {
          transform: rotate(180deg) translateX(5px);
        }

        stroke: ${(props) => props.theme.colors.ui.hover};
      }
    }
  }
`;
export const StyledArrow = styled.svg `
  flex-shrink: 0;
  width: 0.5em;
  height: 0.8125em;
  margin-inline-start: 0.25em;

  transition: 250ms ${(props) => props.theme.easing};
  transition-property: transform, stroke;

  [dir='rtl'] & {
    transform: rotate(180deg);
  }
`;
export const StyledIconContainer = styled.div `
  flex-grow: 0;
  flex-shrink: 0;
  width: 24px;
  height: 24px;

  overflow: hidden;
`;
export const StyledButton = styled.button `
  ${injectCommonButtonStyles}
  ${(props) => {
    switch (props.variant) {
        case 'primary':
        case 'secondary':
            return injectBlockButtonStyles();
        case 'text':
            return injectTextButtonStyles();
    }
}}
`;
//# sourceMappingURL=Button.styles.js.map